import { Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
const ImpulsiveMeterRegistry = ({ result, enteredFromParent }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    console.log("impulsres", result);
  }, [result]);

  return (
    <Grid container>
      <Grid itex xs={!enteredFromParent ? 3 : 4}>
        <Typography variant="subtitle2">Wmbus address</Typography>
        <Typography>{result?.wmbus_address}</Typography>
      </Grid>

      <Grid itex xs={!enteredFromParent ? 3 : 4}>
        <Typography variant="subtitle2">{t("time_zone")}</Typography>
        <Typography>Europe/Rome</Typography>
      </Grid>
      <Grid itex xs={!enteredFromParent ? 3 : 4}>
        <Typography variant="subtitle2">{t("meter_type")} :</Typography>
        <Typography>{result?.meter_type}</Typography>
      </Grid>
      {!enteredFromParent && result?.parent && (
        <Grid item xs={3}>
          <Typography variant="subtitle2"> Parent :</Typography>
          <IconButton onClick={() => navigate(`/meters/${result?.parent}`)}>
            <VisibilityIcon />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};
export default ImpulsiveMeterRegistry;
